import {cfetch} from "../helpers/wrappers";
import {convertObjToQueryParams} from "../helpers/utils";

export default class ProductoService {

    async filtrarProds(bodyParams, queryParams = {}) {
        const config = {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            url: `/api/productos/filter?${convertObjToQueryParams(queryParams)}`,
            body: JSON.stringify(bodyParams),
            method: "POST"
        };
        return await cfetch(config);
    }

    async obtenerVentasPorSucursalPeriodo(IdSucursal, FechaInicio, FechaFin) {
        const config = {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            url: `/api/productos/ventas-sucursal-periodo`,
            body: JSON.stringify({
                IdSucursal,
                FechaInicio,
                FechaFin
            }),
            method: "POST"
        };
        return await cfetch(config);
    }

    async obtenerComprasPorSucursalPeriodo(IdSucursal, FechaInicio, FechaFin) {
        const config = {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            url: `/api/productos/compras-sucursal-periodo`,
            body: JSON.stringify({
                IdSucursal,
                FechaInicio,
                FechaFin
            }),
            method: "POST"
        };
        return await cfetch(config);
    }

    async obtenerHistorialComprasProducto(IdProducto) {
        const config = {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            url: `/api/productos/historial-compras-producto`,
            body: JSON.stringify({
                IdProducto
            }),
            method: "POST"
        };
        return await cfetch(config);
    }


    async filtrarSucursalesProds(bodyParams) {
        const sucursalesReq = await fetch('/api/configFactElectronica/SucursalEmpresa');

        if (!sucursalesReq.ok) {
            return [];
        }

        const sucursales = await sucursalesReq.json();

        const tasks = sucursales.map(async sucursal => this.filtrarProds(bodyParams, {idSucursal: sucursal.IdSucursal}));

        const sucursalesProds = await Promise.all(tasks);

        const productos = {};
        let pages = 0;

        sucursalesProds.forEach((x, index) => {
            if (!x || !x.productos) return;

            if (x.pages > pages) {
                pages = x.pages;
            }

            x.productos.filter(p => p !== null && p !== undefined).forEach(p => {
                if (!p || !p.nombre) {
                    console.warn('Producto inválido encontrado:', p);
                    return;
                }

                if (!(p.nombre in productos)) {
                    productos[p.nombre] = {
                        id: p.id,
                        nombre: p.nombre,
                        codigo: p.codigo,
                        CodigoBarra: p.CodigoBarra
                    };

                    sucursales.forEach(sucursal => {
                        productos[p.nombre][`Sucursal${sucursal.IdSucursal}`] = 0;
                    });
                }

                productos[p.nombre][`Sucursal${sucursales[index].IdSucursal}`] = p.sdcc;
            });
        });

        return {
            productos: Object.values(productos),
            pages: pages,
            sucursales: sucursales
        };
    }

    async obtenerVentasSucursalesProds(fechaInicio, fechaFin) {
        try {
            const sucursalesReq = await fetch('/api/configFactElectronica/SucursalEmpresa');
            
            if (!sucursalesReq.ok) {
                throw new Error('Error al obtener sucursales');
            }

            const sucursales = await sucursalesReq.json();

            const tasksVentas = sucursales.map(async sucursal => {
                const ventas = await this.obtenerVentasPorSucursalPeriodo(
                    sucursal.IdSucursal,
                    fechaInicio,
                    fechaFin
                );
                return {
                    sucursalId: sucursal.IdSucursal,
                    sucursalNombre: sucursal.Nombre,
                    ventas: Array.isArray(ventas) ? ventas : []
                };
            });

            const resultadosVentas = await Promise.all(tasksVentas);

            const productosVentas = {};

            resultadosVentas.forEach(resultado => {
                const { sucursalId, ventas } = resultado;
                
                ventas.forEach(venta => {
                    const clave = venta.Codigo || venta.IdProducto;
                    
                    if (!productosVentas[clave]) {
                        productosVentas[clave] = {
                            codigo: venta.Codigo,
                            nombre: venta.Producto,
                            IdProducto: venta.IdProducto,
                            ...sucursales.reduce((acc, s) => {
                                acc[`Sucursal${s.IdSucursal}_Cantidad`] = 0;
                                acc[`Sucursal${s.IdSucursal}_Total`] = 0;
                                acc[`Sucursal${s.IdSucursal}_Ventas`] = 0;
                                return acc;
                            }, {})
                        };
                    }
                    
                    productosVentas[clave][`Sucursal${sucursalId}_Cantidad`] = parseFloat(venta.CantidadVendida);
                    productosVentas[clave][`Sucursal${sucursalId}_Total`] = parseFloat(venta.TotalVendido);
                    productosVentas[clave][`Sucursal${sucursalId}_Ventas`] = parseInt(venta.NumeroVentas);
                });
            });

            const productosArray = Object.values(productosVentas).map(producto => {
                const totalCantidad = sucursales.reduce((sum, s) => 
                    sum + (producto[`Sucursal${s.IdSucursal}_Cantidad`] || 0), 0);
                
                const totalMonto = sucursales.reduce((sum, s) => 
                    sum + (producto[`Sucursal${s.IdSucursal}_Total`] || 0), 0);
                
                const totalVentas = sucursales.reduce((sum, s) => 
                    sum + (producto[`Sucursal${s.IdSucursal}_Ventas`] || 0), 0);

                return {
                    ...producto,
                    totalCantidad,
                    totalMonto,
                    totalVentas
                };
            });

            return {
                productos: productosArray,
                sucursales: sucursales,
                periodo: {
                    fechaInicio,
                    fechaFin
                }
            };

        } catch (error) {
            console.error('Error en obtenerVentasSucursalesProds:', error);
            throw error;
        }
    }

    async obtenerComprasSucursalesProds(fechaInicio, fechaFin) {
        try {
            const sucursalesReq = await fetch('/api/configFactElectronica/SucursalEmpresa');
            
            if (!sucursalesReq.ok) {
                throw new Error('Error al obtener sucursales');
            }

            const sucursales = await sucursalesReq.json();

            const tasksCompras = sucursales.map(async sucursal => {
                const compras = await this.obtenerComprasPorSucursalPeriodo(
                    sucursal.IdSucursal,
                    fechaInicio,
                    fechaFin
                );
                return {
                    sucursalId: sucursal.IdSucursal,
                    sucursalNombre: sucursal.Nombre,
                    compras: Array.isArray(compras) ? compras : []
                };
            });

            const resultadosCompras = await Promise.all(tasksCompras);

            const productosCompras = {};

            resultadosCompras.forEach(resultado => {
                const { sucursalId, compras } = resultado;
                
                compras.forEach(compra => {
                    const clave = compra.Codigo || compra.IdProducto;
                    
                    if (!productosCompras[clave]) {
                        productosCompras[clave] = {
                            codigo: compra.Codigo,
                            nombre: compra.Producto,
                            IdProducto: compra.IdProducto,
                            ...sucursales.reduce((acc, s) => {
                                acc[`Sucursal${s.IdSucursal}_CompraCantidad`] = 0;
                                acc[`Sucursal${s.IdSucursal}_CompraTotal`] = 0;
                                acc[`Sucursal${s.IdSucursal}_Compras`] = 0;
                                return acc;
                            }, {})
                        };
                    }
                    
                    productosCompras[clave][`Sucursal${sucursalId}_CompraCantidad`] = parseFloat(compra.CantidadComprada);
                    productosCompras[clave][`Sucursal${sucursalId}_CompraTotal`] = parseFloat(compra.TotalComprado);
                    productosCompras[clave][`Sucursal${sucursalId}_Compras`] = parseInt(compra.NumeroCompras);
                });
            });

            const productosArray = Object.values(productosCompras).map(producto => {
                const totalCompraCantidad = sucursales.reduce((sum, s) => 
                    sum + (producto[`Sucursal${s.IdSucursal}_CompraCantidad`] || 0), 0);
                
                const totalCompraMonto = sucursales.reduce((sum, s) => 
                    sum + (producto[`Sucursal${s.IdSucursal}_CompraTotal`] || 0), 0);
                
                const totalCompras = sucursales.reduce((sum, s) => 
                    sum + (producto[`Sucursal${s.IdSucursal}_Compras`] || 0), 0);

                return {
                    ...producto,
                    totalCompraCantidad,
                    totalCompraMonto,
                    totalCompras
                };
            });

            return {
                productos: productosArray,
                sucursales: sucursales,
                periodo: {
                    fechaInicio,
                    fechaFin
                }
            };

        } catch (error) {
            console.error('Error en obtenerComprasSucursalesProds:', error);
            throw error;
        }
    }

    async obtenerStockVentasCompras(fechaInicio, fechaFin, bodyParams = {}) {
        try {
            const stockData = await this.filtrarSucursalesProds(bodyParams);
            
            const ventasData = await this.obtenerVentasSucursalesProds(fechaInicio, fechaFin);
            
            const comprasData = await this.obtenerComprasSucursalesProds(fechaInicio, fechaFin);

            const productosCombinados = stockData.productos.map(productoStock => {
                const resultado = { ...productoStock };
                
                const productoVentas = ventasData.productos.find(
                    pv => pv.codigo === productoStock.codigo
                );
                
                if (productoVentas) {
                    Object.keys(productoVentas).forEach(key => {
                        if (!resultado[key]) {
                            resultado[key] = productoVentas[key];
                        }
                    });
                } else {
                    if (ventasData.sucursales && ventasData.sucursales.forEach) {
                        ventasData.sucursales.forEach(s => {
                            resultado[`Sucursal${s.IdSucursal}_Cantidad`] = 0;
                            resultado[`Sucursal${s.IdSucursal}_Total`] = 0;
                            resultado[`Sucursal${s.IdSucursal}_Ventas`] = 0;
                        });
                    }
                    resultado.totalCantidad = 0;
                    resultado.totalMonto = 0;
                    resultado.totalVentas = 0;
                }
                
                const productoCompras = comprasData.productos.find(
                    pc => pc.codigo === productoStock.codigo
                );
                
                if (productoCompras) {
                    Object.keys(productoCompras).forEach(key => {
                        if (!resultado[key]) {
                            resultado[key] = productoCompras[key];
                        }
                    });
                } else {
                    if (comprasData.sucursales && comprasData.sucursales.forEach) {
                        comprasData.sucursales.forEach(s => {
                            resultado[`Sucursal${s.IdSucursal}_CompraCantidad`] = 0;
                            resultado[`Sucursal${s.IdSucursal}_CompraTotal`] = 0;
                            resultado[`Sucursal${s.IdSucursal}_Compras`] = 0;
                        });
                    }
                    resultado.totalCompraCantidad = 0;
                    resultado.totalCompraMonto = 0;
                    resultado.totalCompras = 0;
                }

                return resultado;
            });

            const productosSoloCompras = comprasData.productos.filter(
                pc => !stockData.productos.some(ps => ps.codigo === pc.codigo)
            );

            const productosSoloVentas = ventasData.productos.filter(
                pv => !stockData.productos.some(ps => ps.codigo === pv.codigo) &&
                      !productosSoloCompras.some(pc => pc.codigo === pv.codigo)
            );

            const todosProductos = [
                ...productosCombinados,
                ...productosSoloCompras.map(pc => {
                    const producto = {
                        ...pc,
                        ...(stockData.sucursales && stockData.sucursales.reduce ? stockData.sucursales.reduce((acc, s) => {
                            acc[`Sucursal${s.IdSucursal}`] = 0;
                            return acc;
                        }, {}) : {})
                    };
                    
                    if (!ventasData.productos.some(pv => pv.codigo === pc.codigo)) {
                        producto.totalCantidad = 0;
                        producto.totalMonto = 0;
                        producto.totalVentas = 0;
                        if (ventasData.sucursales && ventasData.sucursales.forEach) {
                            ventasData.sucursales.forEach(s => {
                                producto[`Sucursal${s.IdSucursal}_Cantidad`] = 0;
                                producto[`Sucursal${s.IdSucursal}_Total`] = 0;
                                producto[`Sucursal${s.IdSucursal}_Ventas`] = 0;
                            });
                        }
                    }
                    
                    return producto;
                }),
                ...productosSoloVentas.map(pv => {
                    const producto = {
                        ...pv,
                        ...(stockData.sucursales && stockData.sucursales.reduce ? stockData.sucursales.reduce((acc, s) => {
                            acc[`Sucursal${s.IdSucursal}`] = 0;
                            return acc;
                        }, {}) : {})
                    };
                    
                    if (!comprasData.productos.some(pc => pc.codigo === pv.codigo)) {
                        producto.totalCompraCantidad = 0;
                        producto.totalCompraMonto = 0;
                        producto.totalCompras = 0;
                        if (comprasData.sucursales && comprasData.sucursales.forEach) {
                            comprasData.sucursales.forEach(s => {
                                producto[`Sucursal${s.IdSucursal}_CompraCantidad`] = 0;
                                producto[`Sucursal${s.IdSucursal}_CompraTotal`] = 0;
                                producto[`Sucursal${s.IdSucursal}_Compras`] = 0;
                            });
                        }
                    }
                    
                    return producto;
                })
            ];

            return {
                productos: todosProductos,
                sucursales: stockData.sucursales || ventasData.sucursales || comprasData.sucursales || [],
                periodo: {
                    fechaInicio,
                    fechaFin
                },
                pages: stockData.pages || 1
            };

        } catch (error) {
            console.error('Error en obtenerStockVentasCompras:', error);
            throw error;
        }
    }

    async obtenerBalanceProductos(fechaInicio, fechaFin, bodyParams = {}) {
        try {
            const data = await this.obtenerStockVentasCompras(fechaInicio, fechaFin, bodyParams);
            
            const productosConBalance = data.productos.map(producto => {
                const resultado = { ...producto };
                
                if (data.sucursales && data.sucursales.forEach) {
                    data.sucursales.forEach(s => {
                        const stockActual = producto[`Sucursal${s.IdSucursal}`] || 0;
                        const compras = producto[`Sucursal${s.IdSucursal}_CompraCantidad`] || 0;
                        const ventas = producto[`Sucursal${s.IdSucursal}_Cantidad`] || 0;
                        
                        resultado[`Sucursal${s.IdSucursal}_Balance`] = stockActual + compras - ventas;
                        
                        resultado[`Sucursal${s.IdSucursal}_Diferencia`] = compras - ventas;
                    });
                }
                
                const totalStock = data.sucursales ? data.sucursales.reduce((sum, s) => 
                    sum + (producto[`Sucursal${s.IdSucursal}`] || 0), 0) : 0;
                const totalCompras = producto.totalCompraCantidad || 0;
                const totalVentas = producto.totalCantidad || 0;
                
                resultado.totalBalance = totalStock + totalCompras - totalVentas;
                resultado.totalDiferencia = totalCompras - totalVentas;
                
                return resultado;
            });

            return {
                ...data,
                productos: productosConBalance
            };

        } catch (error) {
            console.error('Error en obtenerBalanceProductos:', error);
            throw error;
        }
    }


    async obtenerAnalisisProductos(fechaInicio, fechaFin, bodyParams = {}) {
        try {
            // Obtener datos históricos
            const data = await this.obtenerStockVentasCompras(fechaInicio, fechaFin, bodyParams);
            
            const productosAnalizados = data.productos.map(producto => {
                const analisis = { ...producto };
                const sucursales = data.sucursales || [];
                
                // 1. Cálculo de ratios básicos
                sucursales.forEach(s => {
                    const stock = producto[`Sucursal${s.IdSucursal}`] || 0;
                    const ventas = producto[`Sucursal${s.IdSucursal}_Cantidad`] || 0;
                    const compras = producto[`Sucursal${s.IdSucursal}_CompraCantidad`] || 0;
                    const diasPeriodo = this.calcularDiasPeriodo(fechaInicio, fechaFin);
                    
                    // Ratio de rotación de inventario
                    if (stock > 0) {
                        analisis[`Sucursal${s.IdSucursal}_Rotacion`] = (ventas / stock).toFixed(2);
                    } else {
                        analisis[`Sucursal${s.IdSucursal}_Rotacion`] = ventas > 0 ? "∞" : "0";
                    }
                    
                    // Demanda diaria promedio
                    analisis[`Sucursal${s.IdSucursal}_DemandaDiaria`] = (ventas / diasPeriodo).toFixed(2);
                    
                    // Tasa de reposición (compras/ventas)
                    if (ventas > 0) {
                        analisis[`Sucursal${s.IdSucursal}_TasaReposicion`] = (compras / ventas).toFixed(2);
                    } else {
                        analisis[`Sucursal${s.IdSucursal}_TasaReposicion`] = compras > 0 ? "∞" : "0";
                    }
                    
                    // Nivel de servicio (stock/ventas en días)
                    if (ventas > 0) {
                        analisis[`Sucursal${s.IdSucursal}_DiasStock`] = (stock / (ventas / diasPeriodo)).toFixed(1);
                    } else {
                        analisis[`Sucursal${s.IdSucursal}_DiasStock`] = stock > 0 ? "∞" : "0";
                    }
                });
                
                // 2. Predicciones a nivel global del producto
                const totalStock = sucursales.reduce((sum, s) => sum + (producto[`Sucursal${s.IdSucursal}`] || 0), 0);
                const totalVentas = producto.totalCantidad || 0;
                const totalCompras = producto.totalCompraCantidad || 0;
                const diasPeriodo = this.calcularDiasPeriodo(fechaInicio, fechaFin);
                
                // Demanda total diaria
                const demandaDiariaTotal = totalVentas / diasPeriodo;
                analisis.demandaDiariaTotal = demandaDiariaTotal.toFixed(2);
                
                // Stock disponible en días
                if (demandaDiariaTotal > 0) {
                    analisis.diasStockTotal = (totalStock / demandaDiariaTotal).toFixed(1);
                } else {
                    analisis.diasStockTotal = totalStock > 0 ? "∞" : "0";
                }
                
                // 3. Recomendaciones de compra
                analisis.recomendacion = this.generarRecomendacion(producto, sucursales, demandaDiariaTotal, diasPeriodo);
                
                // 4. Punto de reorden (ROP)
                const leadTimePromedio = 7; // Días promedio para recibir mercadería (ajustable)
                analisis.puntoReorden = Math.ceil(demandaDiariaTotal * leadTimePromedio * 1.2); // +20% de seguridad
                
                // 5. Cantidad económica de pedido (EOQ)
                if (totalVentas > 0) {
                    const costoPedido = 50; // Costo administrativo por pedido (ajustable)
                    const costoMantenimiento = 0.20; // 20% del costo unitario anual (ajustable)
                    const costoUnitario = this.estimarCostoUnitario(producto, totalCompras, sucursales);
                    
                    if (costoUnitario > 0) {
                        const eoq = Math.sqrt((2 * totalVentas * costoPedido) / (costoUnitario * costoMantenimiento));
                        analisis.cantidadEconomicaPedido = Math.ceil(eoq);
                    }
                }
                
                return analisis;
            });
            
            return {
                ...data,
                productos: productosAnalizados,
                periodo: {
                    fechaInicio,
                    fechaFin,
                    dias: this.calcularDiasPeriodo(fechaInicio, fechaFin)
                }
            };
            
        } catch (error) {
            console.error('Error en obtenerAnalisisProductos:', error);
            throw error;
        }
    }

    // Funciones auxiliares para predicciones
    calcularDiasPeriodo(fechaInicio, fechaFin) {
        const inicio = new Date(fechaInicio);
        const fin = new Date(fechaFin);
        const diferenciaMs = fin - inicio;
        const dias = Math.ceil(diferenciaMs / (1000 * 60 * 60 * 24)) + 1; // Incluye ambos días
        return Math.max(dias, 1); // Mínimo 1 día
    }

    estimarCostoUnitario(producto, totalCompras, sucursales) {
        // Estimar costo unitario basado en compras históricas
        let cantidadTotalComprada = 0;
        let montoTotalComprado = 0;
        
        sucursales.forEach(s => {
            cantidadTotalComprada += producto[`Sucursal${s.IdSucursal}_CompraCantidad`] || 0;
            montoTotalComprado += producto[`Sucursal${s.IdSucursal}_CompraTotal`] || 0;
        });
        
        if (cantidadTotalComprada > 0 && montoTotalComprado > 0) {
            return montoTotalComprado / cantidadTotalComprada;
        }
        
        // Si no hay datos de compras, estimar basado en ventas (asumiendo 30% margen)
        let cantidadTotalVendida = 0;
        let montoTotalVendido = 0;
        
        sucursales.forEach(s => {
            cantidadTotalVendida += producto[`Sucursal${s.IdSucursal}_Cantidad`] || 0;
            montoTotalVendido += producto[`Sucursal${s.IdSucursal}_Total`] || 0;
        });
        
        if (cantidadTotalVendida > 0 && montoTotalVendido > 0) {
            const precioPromedioVenta = montoTotalVendido / cantidadTotalVendida;
            return precioPromedioVenta * 0.70; // Asume 30% de margen
        }
        
        return 10; // Valor por defecto si no hay datos
    }

    generarRecomendacion(producto, sucursales, demandaDiariaTotal, diasPeriodo) {
        const totalStock = sucursales.reduce((sum, s) => sum + (producto[`Sucursal${s.IdSucursal}`] || 0), 0);
        const totalVentas = producto.totalCantidad || 0;
        
        // Calcular días de stock
        let diasStock = 0;
        if (demandaDiariaTotal > 0) {
            diasStock = totalStock / demandaDiariaTotal;
        } else {
            diasStock = totalStock > 0 ? 999 : 0;
        }
        
        // Umbrales para recomendaciones
        const UMBRAL_BAJO_STOCK = 7; // Días
        const UMBRAL_ALTO_STOCK = 30; // Días
        const UMBRAL_CRITICO_STOCK = 3; // Días
        
        if (totalStock === 0) {
            if (totalVentas > 0) {
                return {
                    nivel: 'CRITICO',
                    mensaje: 'SIN STOCK - Urgente comprar',
                    accion: 'Comprar inmediatamente',
                    cantidadSugerida: Math.ceil(demandaDiariaTotal * 14), // 2 semanas de demanda
                    prioridad: 1
                };
            } else {
                return {
                    nivel: 'INACTIVO',
                    mensaje: 'Sin stock ni ventas recientes',
                    accion: 'Evaluar necesidad',
                    cantidadSugerida: 0,
                    prioridad: 4
                };
            }
        } else if (diasStock < UMBRAL_CRITICO_STOCK) {
            return {
                nivel: 'CRITICO',
                mensaje: `Stock crítico (${diasStock.toFixed(1)} días)`,
                accion: 'Comprar urgentemente',
                cantidadSugerida: Math.ceil(demandaDiariaTotal * 21 - totalStock), // 3 semanas
                prioridad: 1
            };
        } else if (diasStock < UMBRAL_BAJO_STOCK) {
            return {
                nivel: 'BAJO',
                mensaje: `Stock bajo (${diasStock.toFixed(1)} días)`,
                accion: 'Comprar pronto',
                cantidadSugerida: Math.ceil(demandaDiariaTotal * 14 - totalStock), // 2 semanas
                prioridad: 2
            };
        } else if (diasStock > UMBRAL_ALTO_STOCK) {
            return {
                nivel: 'ALTO',
                mensaje: `Stock alto (${diasStock.toFixed(1)} días)`,
                accion: 'No comprar',
                cantidadSugerida: 0,
                prioridad: 4
            };
        } else {
            return {
                nivel: 'OPTIMO',
                mensaje: `Stock óptimo (${diasStock.toFixed(1)} días)`,
                accion: 'Monitorear',
                cantidadSugerida: Math.ceil(demandaDiariaTotal * 7), // 1 semana para mantener
                prioridad: 3
            };
        }
    }

    // Función específica para predicciones de compra
    async obtenerPrediccionesCompra(fechaInicio, fechaFin, diasProyeccion = 30, bodyParams = {}) {
        try {
            const analisis = await this.obtenerAnalisisProductos(fechaInicio, fechaFin, bodyParams);
            
            const predicciones = analisis.productos.map(producto => {
                const pred = { ...producto };
                const sucursales = analisis.sucursales || [];
                
                // Proyección de demanda para los próximos X días
                const demandaDiariaTotal = parseFloat(producto.demandaDiariaTotal) || 0;
                pred.demandaProyectada = Math.ceil(demandaDiariaTotal * diasProyeccion);
                
                // Stock actual total
                const stockActual = sucursales.reduce((sum, s) => 
                    sum + (producto[`Sucursal${s.IdSucursal}`] || 0), 0);
                pred.stockActual = stockActual;
                
                // Días hasta agotarse
                if (demandaDiariaTotal > 0) {
                    pred.diasHastaAgotar = Math.floor(stockActual / demandaDiariaTotal);
                } else {
                    pred.diasHastaAgotar = stockActual > 0 ? 999 : 0;
                }
                
                // ¿Necesita compra en los próximos X días?
                pred.necesitaCompra = pred.diasHastaAgotar < diasProyeccion;
                
                // Cantidad sugerida para comprar
                if (pred.necesitaCompra && producto.recomendacion) {
                    pred.cantidadRecomendada = producto.recomendacion.cantidadSugerida;
                    pred.fechaRecomendadaCompra = this.calcularFechaRecomendadaCompra(pred.diasHastaAgotar);
                } else {
                    pred.cantidadRecomendada = 0;
                    pred.fechaRecomendadaCompra = 'No requiere';
                }
                
                // Prioridad de compra (1: Alta, 4: Baja)
                pred.prioridadCompra = producto.recomendacion?.prioridad || 4;
                
                return pred;
            });
            
            // Ordenar por prioridad
            const prediccionesOrdenadas = predicciones.sort((a, b) => 
                (a.prioridadCompra || 4) - (b.prioridadCompra || 4)
            );
            
            return {
                ...analisis,
                productos: prediccionesOrdenadas,
                proyeccion: {
                    dias: diasProyeccion,
                    fechaInicioProyeccion: new Date().toISOString().split('T')[0],
                    fechaFinProyeccion: this.sumarDias(new Date(), diasProyeccion)
                }
            };
            
        } catch (error) {
            console.error('Error en obtenerPrediccionesCompra:', error);
            throw error;
        }
    }

    calcularFechaRecomendadaCompra(diasHastaAgotar) {
        const hoy = new Date();
        const fechaRecomendada = new Date(hoy);
        
        // Recomendar compra 5 días antes de agotarse
        const diasAdelanto = Math.max(5, Math.floor(diasHastaAgotar * 0.3));
        fechaRecomendada.setDate(fechaRecomendada.getDate() + Math.max(0, diasHastaAgotar - diasAdelanto));
        
        return fechaRecomendada.toISOString().split('T')[0];
    }

    sumarDias(fecha, dias) {
        const nuevaFecha = new Date(fecha);
        nuevaFecha.setDate(nuevaFecha.getDate() + dias);
        return nuevaFecha.toISOString().split('T')[0];
    }

    async analisisABCProductos(fechaInicio, fechaFin, bodyParams = {}) {
        try {
            const data = await this.obtenerStockVentasCompras(fechaInicio, fechaFin, bodyParams);
            

            const productosConValor = data.productos.map(producto => {
                const valorTotalVendido = producto.totalMonto || 0;
                return {
                    ...producto,
                    valorTotalVendido
                };
            });
            
            productosConValor.sort((a, b) => b.valorTotalVendido - a.valorTotalVendido);
            
            // Calcular acumulado y clasificación ABC
            let acumulado = 0;
            const valorTotal = productosConValor.reduce((sum, p) => sum + p.valorTotalVendido, 0);
            
            const productosClasificados = productosConValor.map((producto, index) => {
                acumulado += producto.valorTotalVendido;
                const porcentajeAcumulado = (acumulado / valorTotal) * 100;
                
                let clasificacion = 'C';
                if (porcentajeAcumulado <= 80) {
                    clasificacion = 'A';
                } else if (porcentajeAcumulado <= 95) {
                    clasificacion = 'B';
                }
                
                return {
                    ...producto,
                    ranking: index + 1,
                    porcentajeValor: (producto.valorTotalVendido / valorTotal * 100).toFixed(2),
                    porcentajeAcumulado: porcentajeAcumulado.toFixed(2),
                    clasificacionABC: clasificacion,
                    estrategiaCompra: this.generarEstrategiaCompraABC(clasificacion)
                };
            });
            
            return {
                ...data,
                productos: productosClasificados,
                resumenABC: {
                    totalProductos: productosClasificados.length,
                    totalValor: valorTotal,
                    productosA: productosClasificados.filter(p => p.clasificacionABC === 'A').length,
                    productosB: productosClasificados.filter(p => p.clasificacionABC === 'B').length,
                    productosC: productosClasificados.filter(p => p.clasificacionABC === 'C').length
                }
            };
            
        } catch (error) {
            console.error('Error en analisisABCProductos:', error);
            throw error;
        }
    }

    generarEstrategiaCompraABC(clasificacion) {
        switch(clasificacion) {
            case 'A':
                return {
                    tipo: 'Control estricto',
                    frecuenciaRevision: 'Diaria',
                    nivelServicio: 'Alto (95-98%)',
                    politicaStock: 'Stock bajo, compras frecuentes',
                    recomendacion: 'Seguimiento continuo, pedidos pequeños y frecuentes'
                };
            case 'B':
                return {
                    tipo: 'Control moderado',
                    frecuenciaRevision: 'Semanal',
                    nivelServicio: 'Medio (90-95%)',
                    politicaStock: 'Stock moderado',
                    recomendacion: 'Pedidos regulares, cantidad económica de pedido'
                };
            case 'C':
                return {
                    tipo: 'Control simple',
                    frecuenciaRevision: 'Mensual',
                    nivelServicio: 'Básico (85-90%)',
                    politicaStock: 'Stock alto',
                    recomendacion: 'Pedidos grandes y esporádicos'
                };
            default:
                return {
                    tipo: 'Sin clasificar',
                    frecuenciaRevision: 'Evaluar',
                    nivelServicio: 'Variable',
                    politicaStock: 'Por determinar',
                    recomendacion: 'Analizar histórico'
                };
        }
    }
}
